import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarTasks = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.74 3.897C4.725 2.841 6.127 2.25 7.782 2.25h8.435c1.66 0 3.062.59 4.046 1.648.978 1.05 1.487 2.5 1.487 4.128v7.948c0 1.627-.509 3.078-1.487 4.128-.985 1.057-2.387 1.648-4.047 1.648H7.782c-1.66 0-3.062-.59-4.045-1.648-.979-1.05-1.487-2.501-1.487-4.128V8.026c0-1.628.511-3.078 1.49-4.129M4.837 4.92C4.16 5.647 3.75 6.71 3.75 8.026v7.948c0 1.317.409 2.38 1.085 3.106.67.72 1.658 1.17 2.947 1.17h8.434c1.29 0 2.278-.45 2.949-1.17.676-.726 1.085-1.789 1.085-3.106V8.026c0-1.317-.409-2.38-1.085-3.106-.67-.72-1.66-1.17-2.948-1.17H7.782c-1.284 0-2.273.45-2.945 1.17"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.957 15.305a.75.75 0 0 1 .75-.75h4.31a.75.75 0 0 1 0 1.5h-4.31a.75.75 0 0 1-.75-.75M10.424 13.29a.75.75 0 0 1 0 1.06L8.82 15.954a.75.75 0 0 1-1.06 0l-.824-.823a.75.75 0 0 1 1.061-1.06l.293.292 1.073-1.072a.75.75 0 0 1 1.06 0M10.424 8.048a.75.75 0 0 1 0 1.06L8.82 10.712a.75.75 0 0 1-1.06 0l-.824-.823a.75.75 0 1 1 1.061-1.06l.293.292 1.073-1.072a.75.75 0 0 1 1.06 0M11.957 10.066a.75.75 0 0 1 .75-.75h4.31a.75.75 0 0 1 0 1.5h-4.31a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarTasks);
export default ForwardRef;
